export default __webpack_public_path__ + "static/media/IMG_4854.4c3147ae.jpg";